document.addEventListener("DOMContentLoaded", function () {
  const videoModalButton = document.querySelectorAll(
    ".video-controller"
  );

  const videoModalElement = document.querySelector(".main-video-container");

  if (videoModalElement && videoModalButton) {
    videoModalButton.forEach((item) => {
      item.addEventListener("click", () => {
        videoModalElement.classList.toggle("video-hidden");
      });
    })

    videoModalElement.addEventListener("click", (e) => {
      const videoElement = document.querySelector(".field-youtube-video");

      if (!videoElement.contains(e.target)) {
        videoModalElement.classList.add("video-hidden");
        videoElement.querySelector("video").pause();
      }
    });
  }

  if (document.querySelector("#toolbar-administration")) {
    const pageContent = document.querySelector("#page-content");

    pageContent.classList.add("toolbar-active");
  }

  //Show Landing page images
  const headerMenuItems = document.querySelectorAll(".header-menu-box *");

  headerMenuItems.forEach((item) => {
    item.classList.add("showheaderitem");
  });

  // Video intro button logic
  const videoIntroElement = document.querySelector(".flexi-layout .video-controller");
  const videoBannerElement = document.querySelector(".layout-item-banner-section.video");

  // Function to handle `show-element` class based on window width
  function updateVideoIntroClass() {
    if (window.innerWidth < 475) {
      videoIntroElement.classList.remove("show-element");
    }
  }

  // Check window width on load
  updateVideoIntroClass();

  // Add resize event listener to check window width dynamically
  window.addEventListener("resize", updateVideoIntroClass);

  if (videoBannerElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Only toggle based on intersection if window width is 475px or more
          if (window.innerWidth >= 475) {
            if (entry.isIntersecting >= 0.3) {
              videoIntroElement.classList.remove("show-element");
            } else {
              videoIntroElement.classList.add("show-element");
            }
          } else {
            // Always remove `show-element` if width is below 475px
            videoIntroElement.classList.remove("show-element");
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(videoBannerElement);
  } else if (videoIntroElement) {
    videoIntroElement.classList.add("show-element");
  }

});